import { MouseEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { HeaderProps, PathMenuItem } from '../../../types/types';
import { menuItems } from '../../../data/data';
import Login from '../Login/Login';
import ProhFile from '../../../assets/files/Prohibited_Services_ContactPay.pdf';
import Privacy from '../../../assets/files/Privacy_and_Cookies_Policy_Contact_Pay.pdf';
import Terms from '../../../assets/files/Terms_and_Conditions_ContactPay.pdf';

const NavBar: React.FC<HeaderProps> = ({
  className,
  setOpen,
  isMobile,
  source,
}) => {
  const [activeItem, setActiveItem] = useState<HTMLLIElement | null>(null);
  const onClick = (e: MouseEvent<HTMLLIElement>) => {
    window.scrollTo(0, 0);
    const target = e.target as HTMLLIElement;
    if (activeItem !== null) {
      activeItem.classList.remove('active');
    }
    target.classList.add('active');
    setActiveItem(target);
    setOpen(false);
  };
  return (
    <ul className={`${className}__list`}>
      {menuItems.map((menu: PathMenuItem) => (
        <li key={menu.id} className={`${className}__item`} onClick={onClick}>
          <Link to={menu.path} className={`${className}__link`}>
            <span className={`${className}__text text-menu`}>{menu.text}</span>
          </Link>
        </li>
      ))}
      {source === 'footer' && (
        <>
          <li key='privacy' className={`${className}__item `} onClick={onClick}>
            <a
              target='_blank'
              href={Privacy}
              rel='noopener noreferrer'
              className={`${className}__link`}
            >
              <span className={`${className}__text text-menu`}>
                Privacy Policy
              </span>
            </a>
          </li>
          <li key='terms' className={`${className}__item `} onClick={onClick}>
            <a
              target='_blank'
              href={Terms}
              rel='noopener noreferrer'
              className={`${className}__link`}
            >
              <span className={`${className}__text text-menu`}>
                Terms & Conditions
              </span>
            </a>
          </li>
          <li
            key='prohFile'
            className={`${className}__item `}
            onClick={onClick}
          >
            <a
              target='_blank'
              href={ProhFile}
              rel='noopener noreferrer'
              className={`${className}__link`}
            >
              <span className={`${className}__text text-menu`}>
                Prohibited Services
              </span>
            </a>
          </li>
        </>
      )}
      {isMobile && (
        <li key='login' className={`${className}__item `} onClick={onClick}>
          <Login className='menu__link' />
        </li>
      )}
    </ul>
  );
};
export default NavBar;
